import React from "react";
import { formatCurrency, formatPercent } from "./ctf-shared-utils";

/**
 * Single toggle row in the table
 * Represents one option within a category
 * Updated for ClickToFlyResult change object format
 */
const TableToggleRow = ({
  option,
  category,
  isSelected,
  onSelect,
  defaultPrice,
}) => {
  const handleClick = () => {
    if (onSelect) {
      onSelect(option);
    }
  };

  // Extract percent and dollar values from change object
  // change.percent is negative for discounts, positive for increases
  const change = option.change || { percent: 0, dollars: 0 };
  const percentValue = change.percent || 0;
  const dollarValue = change.dollars || 0;

  // Determine if this is an increase (positive percent) or discount (negative percent)
  // For YOM: negative = discount, positive = increase (cost more)
  const isIncrease = category === "yom" ? option.isIncrease : percentValue > 0;
  const isDiscount = category === "yom" ? option.isDiscount : percentValue < 0;
  const isDefault = option.isDefault || false;

  return (
    <tr
      className={`toggle-row ${isSelected ? "selected" : ""} ${
        onSelect ? "interactive" : ""
      }`}
      onClick={handleClick}
    >
      <td className="toggle-cell"></td>
      <td className="value-cell">{option.label || option.value}</td>
      <td className="adjustment-cell">
        {percentValue !== 0 ? formatPercent(Math.abs(percentValue)) : "0.0%"}
      </td>
      <td className="check-cell">{isSelected ? "✓" : ""}</td>
      <td
        className={`percent-cell ${
          isDiscount ? "discount" : isIncrease ? "increase" : "neutral"
        }`}
      >
        {percentValue !== 0 ? formatPercent(Math.abs(percentValue)) : "0.0%"}
      </td>
      <td
        className={`dollar-cell ${
          isDiscount ? "discount" : isIncrease ? "increase" : "neutral"
        }`}
      >
        {dollarValue !== 0
          ? `${isIncrease ? "+" : "-"}${formatCurrency(Math.abs(dollarValue))}`
          : formatCurrency(0)}
      </td>
    </tr>
  );
};

export default TableToggleRow;
